import { BaseUrl, JsonConfig } from "./BaseRepository";
import axios from 'axios';


//Api request for Updating New Hire Re Hire Employee data

export const UpdateNewHireReHireEmployee = async (UpdatedData) => {
    try{
        const URL = BaseUrl+"Newhire/updatingManualupload";
        const Response = await axios.put(URL, UpdatedData, JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}

//Api request for Updating New Hire Re Hire Employee data
export const DeleteNewHireReHireEmployee = async (EmployeeId) => {
    try{
        const URL = BaseUrl+"Newhire/DeleteDataingrid?EmployeeID="+EmployeeId;
        const Response = await axios.delete(URL, JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}

//Api request for Updating New Hire Re Hire Employee data
export const AddNewHireReHireEmployee = async (NewRecord) => {
    try{
        const URL = BaseUrl+"Newhire/addnewrow";
        const Response = await axios.post(URL, NewRecord, JsonConfig);
        const JsonResponse = Response !== null ? Response.data : null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}